import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Members, Member, MembershipsV2, IncompleteSignups, RevenueForecast } from './scenes/Customers'
// import { Roadmap } from './scenes/Development'
import { Dashboard } from './scenes/Dashboard'
import StyleGuide from './scenes/StyleGuides'
import { PrivateRoute } from './components/WithAuth'
import { NoAccessPage } from './scenes/NoAccess'
import LandingRedirect from './components/LandingRedirect'
import {
  Location,
  LocationsWrapper,
  LocationEditWrapper
} from './scenes/Locations'
import Admins from './scenes/Admins'
import FreePassV2 from './scenes/FreePasses'

import PaidPassesV2 from './scenes/PaidPasses'
import Documents from './scenes/Documents'
import SmsTemplates from './scenes/SmsTemplates'

import { ReportList, Report } from './scenes/Reports'
import Leads from './scenes/Leads'
import LocationMonitor from './scenes/LocationMonitor'
import PromotionsV2 from './scenes/Promotions'
import { AccessChip, PTPackage } from './scenes/AddOns'
import ProductV2 from './scenes/Products'
import UnderDevelopmentPage from './scenes/UnderDevelopment'
import { ErrorComponent } from './scenes/Error'
import {
  PTListV2,
  NewPT,
  PT,
  EditPTPersonlia,
  EditPTContract,
  EditPTLocations
} from './scenes/PTs'
import FacilityManagement from './scenes/FacilityManagement'
import EgymWellpass from './scenes/EgymWellpass'
import MonitoringWrapper from './scenes/Monitoring'
import KeyManagementWrapper from './scenes/KeyManagement'

const DASHBOARD_VIEW = [
  'reports.view_memberships',
  'reports.view_financial',
  'reports.view_access',
  'reports.view_pts'
]

const REPORTS_VIEW = [
  'reports.view_memberships',
  'reports.view_financial',
  'reports.view_pts'
]

const MemberRoutes = (props) => (
  [
    <PrivateRoute
      key='members'
      exact path='/operators/:operatorID/members'
      permission='memberships.view_memberships'
      component={Members}
      {...props}
    />,
    <PrivateRoute
      key='member'
      path='/operators/:operatorID/members/:memberID'
      permission='memberships.view_memberships'
      component={Member}
      {...props}
    />,
    <PrivateRoute
      key='memberships'
      exact path='/operators/:operatorID/memberships'
      permission='memberships.view_memberships'
      component={MembershipsV2}
      {...props}
    />,
    <PrivateRoute
      key='incomplete-signups'
      exact path='/operators/:operatorID/memberships/incomplete-signups'
      permission='memberships.view_memberships'
      component={IncompleteSignups}
      {...props}
    />,
    <PrivateRoute
      key='revenue-forecast'
      exact path='/operators/:operatorID/memberships/revenue-forecast'
      permission='memberships.view_memberships'
      component={RevenueForecast}
      {...props}
    />
  ]
)

const ProductRoutes = (props) => [
  <PrivateRoute
    key='product'
    path='/operators/:operatorID/product'
    permission='memberships.view_product'
    component={ProductV2}
    {...props}
  />
]

const LeadRoutes = (props) => {
  return [
    <PrivateRoute
      key='leads'
      path='/operators/:operatorID/leads'
      permission='leads.view_leads'
      component={Leads}
      {...props}
    />
  ]
}

const FacilityManagementRoutes = (props) => {
  return [
    <Route
      key='maintenance'
      path='/operators/:operatorID/maintenance'
      component={FacilityManagement}
    />
  ]
}

const WellpassRoutes = (props) => {
  return [
    <Route
      key='egym-wellpass'
      path='/operators/:operatorID/egym-wellpass'
      permission='memberships.view_memberships'
      component={EgymWellpass}
    />
  ]
}

const AddOnRoutes = (props) => [
  <PrivateRoute
    key='add-ons'
    path='/operators/:operatorID/add-ons/access-chip'
    permission='memberships.view_addons'
    component={AccessChip}
    match={props.match}
    {...props}
  />,
  <PrivateRoute
    key='pt-packages'
    path='/operators/:operatorID/add-ons/pt-packages'
    permission='memberships.view_addons'
    component={PTPackage}
    match={props.match}
    {...props}
  />
]

const DummyLinks = () => {
  const baseURL = '/operators/:operatorID'
  return (
    [
      <Route
        key='settings'
        path={`${baseURL}/settings`}
        component={UnderDevelopmentPage}
      />
    ]
  )
}

const LocationRoutes = (props) => {
  const locationPath = '/operators/:operatorID/locations'
  return (
    [
      <PrivateRoute
        key='edit_location'
        exact path={`${locationPath}/:locationID/edit`}
        permission='operators.manage_locations'
        component={LocationEditWrapper}
        {...props}
      />,
      <PrivateRoute
        key='location'
        exact path={`${locationPath}/:locationID`}
        permission='operators.view_locations'
        component={Location}
        {...props}
      />,
      <PrivateRoute
        key='locations'
        path={locationPath}
        permission='operators.view_locations'
        component={LocationsWrapper}
        {...props}
      />,
      <PrivateRoute
        key='location-monitor'
        path='/operators/:operatorID/location-monitor'
        permission='location_monitor.view_settings'
        component={LocationMonitor}
        {...props}
      />
    ]
  )
}

const AdminRoutes = (props) => [
  <PrivateRoute
    key='admins'
    path='/operators/:operatorID/administrators'
    permission='administrators.view_administrators'
    component={Admins}
    {...props}
  />
]

const PaidPassRoutes = (props) => {
  // const paidPassPath = '/operators/:operatorID/paid-passes'
  return (
    [
      <PrivateRoute
        key='paidPasses'
        path='/operators/:operatorID/paid-passes-v2'
        permission='paid_passes.view_passes'
        component={PaidPassesV2}
        {...props}
      />
    ]
  )
}

const FreePassRoutes = (props) => {
  return (
    [
      <PrivateRoute
        key='freePasses'
        path='/operators/:operatorID/free-passes'
        permission='free_passes.view_passes'
        component={FreePassV2}
        {...props}
      />
    ]
  )
}

const ReportRoutes = (props) => {
  const reportPath = '/operators/:operatorID/reports'
  return (
    [
      <PrivateRoute
        key='reports'
        exact path={reportPath}
        permission={REPORTS_VIEW}
        component={ReportList}
        {...props}
      />,
      <PrivateRoute
        key='report'
        exact path={`${reportPath}/:name`}
        permission={REPORTS_VIEW}
        component={Report}
        {...props}
      />
    ]
  )
}

const MonitoringRoutes = (props) => {
  const monitoringPath = '/operators/:operatorID/monitor'

  return (
    [
      <PrivateRoute
        key='monitor'
        exact path={monitoringPath}
        permission='access_control.view_monitor'
        component={MonitoringWrapper}
        {...props}
      />
    ]
  )
}

const KeyManagementRoutes = (props) => {
  const keyManagementPath = '/operators/:operatorID/key-management'

  return (
    [
      <PrivateRoute
        key='key-management'
        exact path={keyManagementPath}
        permission='access_control.view_keys'
        component={KeyManagementWrapper}
        {...props}
      />
    ]
  )
}

const PTRoutes = (props) => {
  const ptPath = '/operators/:operatorID/pts'

  // Had to duplicate routes with exact paths into new microfrontend for legacy components to still work
  return (
    [
      <PrivateRoute
        key='PTsByLocation'
        exact path={`${ptPath}/by-location`}
        permission='pts.view_pts'
        component={PTListV2}
        {...props}
      />,
      <PrivateRoute
        key='PTsById'
        exact path={`${ptPath}/by-pt`}
        permission='pts.view_pts'
        component={PTListV2}
        {...props}
      />,
      <PrivateRoute
        key='newPT'
        exact path={`${ptPath}/new`}
        permission='pts.manage_pts'
        component={NewPT}
        {...props}
      />,
      <PrivateRoute
        key='pt'
        exact path={`${ptPath}/:id`}
        permission='pts.view_pts'
        component={PT}
        {...props}
      />,
      <PrivateRoute
        key='editPTPersonalia'
        exact path={`${ptPath}/:id/personalia/edit`}
        permission='pts.manage_pts'
        component={EditPTPersonlia}
        {...props}
      />,
      <PrivateRoute
        key='editPTContract'
        exact path={`${ptPath}/:id/contract/edit`}
        permission='pts.manage_pts'
        component={EditPTContract}
        {...props}
      />,
      <PrivateRoute
        key='editPTLocations'
        exact path={`${ptPath}/:id/locations/edit`}
        permission='pts.manage_pts'
        component={EditPTLocations}
        {...props}
      />
    ]
  )
}

const PromotionRoutes = (props) => {
  // const promotionPath = '/operators/:operatorID/promotions'
  return (
    [
      <PrivateRoute
        key='listPromotions'
        path='/operators/:operatorID/promotions-v2'
        permission='memberships.view_promotions'
        component={PromotionsV2}
        {...props}
      />
    ]
  )
}

const TemplateRoutes = (props) => {
  return (
    [
      <PrivateRoute
        key='smsTemplates'
        path='/operators/:operatorID/sms-templates'
        permission='memberships.view_templates'
        component={SmsTemplates}
        {...props}
      />
    ]
  )
}

const DocumentRoutes = (props) => {
  return (
    [
      <PrivateRoute
        key='documents'
        path='/operators/:operatorID/documents'
        permission='memberships.view_memberships'
        component={Documents}
        {...props}
      />
    ]
  )
}

const Router = (props) => {
  if (props.error) {
    return (
      <main id='main'>
        <div className='index' style={{ paddingTop: '70px' }}>
          <div className='content-box error'>
            <ErrorComponent error={props.error.reason} />
          </div>
        </div>
      </main>
    )
  }

  return (
    <main id='main'>
      <Switch>
        <PrivateRoute
          path='/dashboard'
          permission={DASHBOARD_VIEW}
          component={Dashboard}
          {...props}
        />
        <Route path='/styleguide' component={StyleGuide} />
        <Route path='/under-development' component={UnderDevelopmentPage} />
        <Route path='/no-access' component={NoAccessPage} />
        {PromotionRoutes(props)}
        {ProductRoutes(props)}
        {AddOnRoutes(props)}
        {LeadRoutes(props)}
        {WellpassRoutes(props)}
        {FacilityManagementRoutes(props)}
        {LocationRoutes(props)}
        {MemberRoutes(props)}
        {DummyLinks()}
        {ReportRoutes(props)}
        {AdminRoutes(props)}
        {FreePassRoutes(props)}
        {PaidPassRoutes(props)}
        {PTRoutes(props)}
        {MonitoringRoutes(props)}
        {KeyManagementRoutes(props)}
        {TemplateRoutes(props)}
        {DocumentRoutes(props)}
        <Route
          path='/'
          render={() => (
            <LandingRedirect user={props.user} operatorID={props.selected_operator} />
          )}
        />
      </Switch>
    </main>
  )
}

export default Router
